import type { ISalesRecommendation } from "@voith-webshop/core-interfaces";
import { createAction } from "typesafe-actions";

export const fetchSalesRecommendation = createAction("FETCH_SALES_RECOMMENDATION")();

export const fetchSalesRecommendationStart = createAction("FETCH_SALES_RECOMMENDATION_START")();

export const fetchSalesRecommendationFail = createAction("FETCH_SALES_RECOMMENDATION_FAIL", (err: Error) => ({
  payload: err,
  error: true
}))();

export const fetchSalesRecommendationSuccess = createAction("FETCH_SALES_RECOMMENDATION_SUCCESS", (payload: ISalesRecommendation[]) => payload)();
